import { useEffect, useState } from 'react';
import nasmApi from '../../api/endpoints';

export default function useFetchExerciseFilters () {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [exerciseFilters, setExerciseFilters] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError(false);

    let isMounted = true;

    nasmApi.nasmExercises.getExerciseFilters().then(data => {
      if (isMounted) {
        setLoading(false);
        setError(false);
        setExerciseFilters(data.result);
      }
    })
      // eslint-disable-next-line handle-callback-err
      .catch(error => {
        if (isMounted) {
          setError(true);
          setLoading(false);
          setExerciseFilters([]);
        }
      });

    return () => { isMounted = false; };
  }, []);

  return { loading, error, exerciseFilters };
}
